import { Component, inject, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '../../shared/shared.module';
import { Router } from '@angular/router';

@Component({
    selector: 'app-alert',
    imports: [SharedModule],
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

    data: any;
    type: string;
    imagePath: string = '';
    submitLabel: string = '';
    cancelLabel: string = '';
    router = inject(Router)

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        public dialogRef: MatDialogRef<AlertComponent>
    ) {

        this.type = dialogData.type;
        this.data = dialogData.data;
        this.cancelLabel = dialogData.data.rightButton;
        this.submitLabel = dialogData.data.leftButton;
        this.imagePath = dialogData.imagePath;
    }

    ngOnInit(): void {
    }

    onSubmitClick(): void {
        this.dialogRef.close({ key: true });
    }

    onCancelClick(): void {
        this.dialogRef.close({ key: false });
    }

    onBtnSuccess() {
        this.dialogRef.close({ key: true })
    }

    onLinkClick() {
        this.router.navigateByUrl('auth/login');
        this.dialogRef.close({ linkClicked: true });
    }
}
